<template>
  <div class="main-content sn-content">
    <el-card class="box-card">
      <el-form v-if="step == 1" ref="form" :model="form" label-width="95px" :rules="rules">
        <el-form-item label="现金余额：">
          ￥ {{userConfig.permanentBalance}}
        </el-form-item>
        <el-form-item label="可用余额：">
          ￥ {{userConfig.permanentBalance + userConfig.timeLimitedBalance ? userConfig.timeLimitedBalance : 0}}
        </el-form-item>
        <el-form-item label="充值方式：">
          <el-alert
            title="微信支付入口已下线，如需充值请联系商务支持。"
            type="warning"
            :closable="false">
          </el-alert>
        </el-form-item>
        <el-form-item label="充值金额：" prop="amount">
          <el-input
            placeholder="请输入金额"
            style="width: 220px"
            v-model="form.amount">
          </el-input>
        </el-form-item>
        <div class="item" style="">
          <el-button type="primary" class="pxy-primary" plain disabled>暂不支持在线充值</el-button>
        </div>
      </el-form>

      <div style="width: 250px" v-show="step==2">
        <div class="vertical" style="height: 50px;text-align: center;line-height: 50px;background: #e5e5e5">
          <img :src="$baseUrl+'img/wxPay.png'"/><span>请微信扫码支付</span>
        </div>
        <div style="padding: 40px 65px;background:#439057 ">
          <div style="color: #fff;margin: 10px -65px;text-align: center;margin-top: 0">待支付金额：￥{{form.amount}}</div>
          <div style="padding: 10px;background: #fff" class="qrcode" ref="qrcodeContainer">
          </div>
        </div>
        <div class="item" style="margin-top: 10px">
          <el-button type="primary" class="pxy-primary" plain @click="step = '1'">取消</el-button>
          <router-link :to="{path:'/console'}" style="float: right">
            <el-button type="primary" class="pxy-primary" plain >已支付，查看余额</el-button>
          </router-link>
        </div>
      </div>
      <p>温馨提示：系统计费错误等问题，请发邮件：包含问题描述、报错截图、联系人电话至邮箱business@paraverse.cc，我们会在1个工作日内处理。</p>
    </el-card>
    <p style="color: #FF6B00;font-size: 16px;line-height: 26px;">
      <i class="el-icon-bell" style="font-weight: 600;font-size: 20px;"></i>
      本网站平台（LarkXR推流软件服务和应用托管服务）是面向新用户的免费测试平台，已不提供在线充值服务，如有具体项目需求请联系平行云商务或拨打热线 <span style="color:#409EFF;">400-678-1024</span> 获取帮助。<br/>如果您仍打算自助使用3D/XR应用公网推流软件，请移步平行云新产品 <el-link  type="primary" :underline="false" href="https://www.immershare.com/" style="color:#FF6B00;font-size: 16px;font-weight:600;" target="_blank"> ImmerShare </el-link>，面向各类3D/XR应用的一键安装工具。每个月仅需59.9元，即可畅享3D应用“极简秒分享，一键推公网”的极致体验。<br/>新用户注册即赠送7天免费使用权益：<el-link  type="primary" :underline="false" href="https://www.immershare.com/" style="color:#409EFF;font-size: 16px;" target="_blank"> www.immershare.com </el-link>
    </p>
  </div>


</template>

<script>
  import {Message} from "element-ui";
  import QRCode from 'qrcodejs2';
  import {isIntegerNotMust} from '@/utils/validator.js'
  import $ from 'jquery'
  export default {
    components: {},
    data() {
      return {
        form: {
          payType: "11",
          amount: "",
        },
        payLogForm:{
          id:""
        },
        userConfig: {},
        step: 1,
        nextBtnDisabled:false,
        rules: {
          amount: [{required: true, message: '请输入充值金额', trigger: 'blur'},
            {validator:isIntegerNotMust}
          ],
        },
      }
    },
    created() {
    },
    methods: {
      uacUserConfig: function () {
        this.getRequest('/uacUserConfig/getInfo', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userConfig = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      showWXCode: function () {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.nextBtnDisabled = true;
            var params = {
              "amount": this.form.amount,
              "payType": this.form.payType
            }
            this.postRequestJson('/ofcRechargeLog/add',params).then(resp => {
              if (resp.status == 200) {
                if (resp.data.code == 1000) {
                  this.step = 2;
                  var result = resp.data.result.code_url;

                  this.getWXEWM(result);
                  this.nextBtnDisabled = false;

                } else {
                  this.nextBtnDisabled = false;
                  Message.error(resp.data.message);
                }
              } else {
                this.nextBtnDisabled = false;
               // Message.error("error");
              }
            })
          }
        })
      },
      getWXEWM:function (result) {
        $(".qrcode").html("");
        let qrCode = new QRCode(this.$refs.qrcodeContainer,{
          width:100,
          height:100,
          colonDark: '#000',
          colonLight: '#fff',
          text: result
        })

      }
    },
    mounted: function () {
      this.uacUserConfig();
    },
    beforeDestroy() {

    }
  }
</script>

